import type { ArtifactResponse } from '@/client/types.gen'

export { formatArtifactLabel } from '@/components/project/artifact-labels'

export const MAX_ANALYSIS_SOURCES = 5

export function getTotalSourceCount(
	primaryFiles: ReadonlyArray<ArtifactResponse>,
	contextFiles: ReadonlyArray<ArtifactResponse>
): number {
	return primaryFiles.length + contextFiles.length
}

export function canAddAnalysisSource(
	primaryFiles: ReadonlyArray<ArtifactResponse>,
	contextFiles: ReadonlyArray<ArtifactResponse>
): boolean {
	return getTotalSourceCount(primaryFiles, contextFiles) < MAX_ANALYSIS_SOURCES
}

export function getCompletedArtifacts(artifacts: ArtifactResponse[]): ArtifactResponse[] {
	return artifacts.filter((artifact) => artifact.status === 'completed')
}

export function getAvailableForContext(
	artifacts: ArtifactResponse[],
	excludedIds: ReadonlyArray<string | null | undefined>
): ArtifactResponse[] {
	const excluded = new Set(
		excludedIds.filter((id): id is string => typeof id === 'string' && id.length > 0)
	)
	return artifacts.filter((artifact) => !excluded.has(artifact.id))
}
